export default __webpack_public_path__ + "static/media/BM.KHCN.03.04 Thống kê tiêu chuẩn, thành tích NCKH và kế hoạch phát triển.7ecc3ab5.docx";